import { usePage } from "@inertiajs/react";
import FlashMessageManager from "@/components/flash-messages/flash-message-manager";
import { SystemAlertBar } from "@/components/system-alert-bar";
import { EventTrackingProvider } from "@/lib/event-tracking/event-tracking-provider";
import type { SharedData } from "@/types";

export function AppProviders() {
  const { auth } = usePage<SharedData>().props;

  return (
    <>
      <SystemAlertBar />
      <FlashMessageManager />
      <EventTrackingProvider user={auth.user} />
    </>
  );
}
